import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaWhatsapp, FaStar, FaRegStar, FaStarHalfAlt } from "react-icons/fa";
// import { FiSearch } from "react-icons/fi";
import { FiChevronDown, FiTruck } from "react-icons/fi";


import { FiPlus, FiMinus, FiHeart,  FiChevronLeft, FiChevronRight } from "react-icons/fi";
// import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import axios from "axios";
import "./ProductDetails.scss";
// import ReviewModal from "../components/ReviewModal";
import ReviewFormModal from "../components/ReviewFormModal";
import ReviewImageGallery from "../components/ReviewImageGallery";
import { MdVerified } from "react-icons/md";
import ImageLightbox from "../components/ImageLightbox";
import ProductActionsExtra from "../components/ProductActionsExtra";
import { FaMoneyBillWave } from "react-icons/fa";
import ProductShare from "../components/ProductShare";
import QuickOrderModal from "../components/QuickOrderModal";


const API = process.env.REACT_APP_BACKEND_URL;

// Color theme
const colors = {
  primary: '#ffffff',
  primaryLight: '#8b6f61',
  primaryDark: '#3f332b',
  primaryFade: '#e8e1dd',
  background: '#faf7f5',
  textPrimary: '#2c2420',
  textSecondary: '#6b5b53',
  border: '#d4ccc7',
  success: '#4c6b5f',
  error: '#b55a4a',
};

const ProductDetails = () => {
  const WHATSAPP_NUMBER = "919834704067";
  const navigate = useNavigate();
  const { id } = useParams();
  // const { addToCart } = useCart();
  const { toggleWishlist, isInWishlist } = useWishlist();

  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedImage, setSelectedImage] = useState(0);
  const [showImageModal, setShowImageModal] = useState(false);
  const [quantity, setQuantity] = useState(1);
  // const [isAdded, setIsAdded] = useState(false);
  const [showToast, setShowToast] = useState(false);
  // const [activeTab, setActiveTab] = useState('description');
  // const [images, setImages] = useState([]);
  const [preview, setPreview] = useState([]);
  const [selectedReview, setSelectedReview] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showCodTerms, setShowCodTerms] = useState(false);
  // const [showAllReviews, setShowAllReviews] = useState(false);
  const [openOrderModal, setOpenOrderModal] = useState(false);
  const [sizeError, setSizeError] = useState(false);


  const [reviewForm, setReviewForm] = useState({
    name: '',
    email: '',
    rating: 5,
    comment: '',

    image: null
  });
  const [reviews, setReviews] = useState([]);
  const reviewImages = reviews.flatMap(r => r.images || []);
  // Accordion states
  const [openSections, setOpenSections] = useState({
    description: true,
    details: false,
    care: false,
    brand: false,
    reviews: false
  });

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    setReviewForm({
      ...reviewForm,
      images: files
    });

    const previewUrls = files.map(file =>
      URL.createObjectURL(file)
    );

    setPreview(previewUrls);
  };
  // eslint-disable-next-line
  useEffect(() => {
    if (!API) return;

    // Fetch product
    axios
      .get(`${API}/api/products/${id}`)
      .then((res) => {
        setProduct(res.data);
        // Fetch related products (same category)
        return axios.get(`${API}/api/products?category=${res.data.category}`);
      })
      .then((res) => {
        setRelatedProducts(res.data.filter(p => p._id !== id).slice(0, 4));
      })
      .catch((err) => console.log(err));
    fetchReviews();
    // eslint-disable-next-line
  }, [id]);

  const fetchReviews = async () => {
    try {
      const res = await axios.get(`${API}/api/reviews/product/${id}`);
      setReviews(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleReviewSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      formData.append("name", reviewForm.name);
      formData.append("email", reviewForm.email);
      formData.append("rating", reviewForm.rating);
      formData.append("comment", reviewForm.comment);
      formData.append("productId", id);

      reviewForm?.images?.forEach((img) => {
        formData.append("images", img);
      });

      const res = await axios.post(
        `${API}/api/reviews`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      // 🔥 Immediate show without refresh
      setReviews([res.data, ...reviews]);

      // reset form
      setReviewForm({
        name: '',
        email: '',
        rating: 5,
        comment: '',
        images: []
      });

      setPreview([]);

      setShowToast({
        message: 'Review submitted successfully!',
        type: 'success'
      });

      setTimeout(() => setShowToast(null), 3000);

    } catch (err) {
      console.log(err);
    }
  };

  const toggleSection = (section) => {
    setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  // const handleAddToCart = () => {
  //   if (!selectedSize) {
  //     setShowToast({ message: 'Please select a size', type: 'error' });
  //     setTimeout(() => setShowToast(null), 3000);
  //     return false; // important
  //   }

    // addToCart({
    //   id: product._id,
    //   name: product.name,
    //   price: product.price,
    //   image: product.mainImage,
    //   size: selectedSize,
    //   quantity
    // });

    // setIsAdded(true); 
  //   setShowToast({ message: 'Added to cart!', type: 'success' });
  //   setTimeout(() => setShowToast(null), 3000);

  //   return true;
  // };

  // const handleCartButtonClick = () => {
  //   if (!isAdded) {
  //     const success = handleAddToCart();
  //     if (!success) return;
  //   } else {
  //     navigate("/cart");
  //   }
  // };
  const calculateAverageRating = () => {
    if (reviews.length === 0) return 0;
    const sum = reviews.reduce((acc, review) => acc + review.rating, 0);
    return (sum / reviews.length).toFixed(1);
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} className="star-filled" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="star-filled" />);
    }
    for (let i = stars.length; i < 5; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} className="star-empty" />);
    }
    return stars;
  };

  
  // const allImages = [product.mainImage, ...(product.otherImages || [])];

const allImages = product ? [product.mainImage, ...(product.otherImages || [])] : [];


if (!product) {
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <p>Loading product details...</p>
      </div>
    );
  }



  const handleCustomOrder = () => {

    const message = `
Hello,

I am interested in a customised order.

• Product: ${product.name}

Customisation Details:
• Preferred Size: ${selectedSize || "Not decided"}
• Preferred Colour: 
• Special Request: 

Product Link:
${window.location.href}

Please let me know if this can be customised.
`;

    const encodedMessage = encodeURIComponent(message);

    const whatsappURL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

    window.open(whatsappURL, "_blank");
  };


  const handleOrderClick = () => {

    if (!selectedSize) {
      setSizeError(true);
      return;
    }

    setSizeError(false);
    setOpenOrderModal(true);
  };




  return (
    <div className="product-details-page">
      {/* Hero Banner */}
      {/* <div className="hero-banner" style={{ background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)` }}>
        <div className="banner-content">
          <h1>{product.name}</h1>
          <p>Home / Products / {product.category} / {product.name}</p>
        </div>
      </div> */}

    
  
      <div
        className="hero-banner"
        style={{
          background: colors.primary,
        }}
      >
        <p className="text-sm md:text-base lg:text-lg mt-4">
          Home / Products / {product.category} / {product.name}
        </p>
      </div>
      <div className="max-w-[1400px] mx-auto px-3 md:px-4">
        {/* Main Product Section */}
        <div className="grid grid-cols-1 lg:grid-cols-[60%_40%] gap-12 items-start">
          {/* Image Gallery */}
          {/* LEFT SIDE - IMAGES */}
          <div className="flex gap-4">

            {/* Thumbnails */}
            <div className="hidden md:flex flex-col gap-3 w-20">
              {allImages.map((img, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedImage(index)}
                  className={`border overflow-hidden transition ${selectedImage === index ? "border-black" : "border-gray-200"
                    }`}
                >
                  <img
                    src={img}
                    alt=""
                    className="w-full h-20 object-cover"
                  />
                </button>
              ))}
            </div>

            {/* Main Image */}
            <div className="relative w-full group cursor-pointer">
              <img
                // src={allImages[selectedImage]}
                src={allImages[selectedImage] || "/placeholder.png"}
                alt={product.name}
                onClick={() => setShowImageModal(true)}
                // className="w-full h-[650px] md:h-[850px] lg:h-[950px] object-cover"
                className="w-full h-[450px] md:h-[700px] lg:h-[950px] object-cover"
              // className="w-full h-[750px] md:h-[950px] lg:h-[1100px] object-cover"
              // className="w-full h-[750px] md:h-[950px] lg:h-[1100px] object-cover transition-transform duration-500 group-hover:scale-95"
              />


              {/* <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
  <div className="bg-white/80 p-3 rounded-full shadow-lg">
    <FiSearch className="text-2xl text-black" />
  </div>
</div> */}
              {/* Wishlist Heart */}
              <button
                onClick={() => toggleWishlist(product)}
                className="absolute top-4 right-4 bg-white/90 backdrop-blur p-2 rounded-full shadow-lg hover:scale-110 transition"
              >
                <FiHeart
                  className={`text-xl ${isInWishlist(product._id) ? "text-red-500" : "text-black"
                    }`}
                />
              </button>

              {/* Arrows */}
              <button
                onClick={() =>
                  setSelectedImage(
                    selectedImage === 0
                      ? allImages.length - 1
                      : selectedImage - 1
                  )
                }
                className="absolute left-3 top-1/2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full"
              >
                <FiChevronLeft />
              </button>

              <button
                onClick={() =>
                  setSelectedImage(
                    selectedImage === allImages.length - 1
                      ? 0
                      : selectedImage + 1
                  )
                }
                className="absolute right-3 top-1/2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full"
              >
                <FiChevronRight />
              </button>




            </div>
          </div>

          {/* Product Info */}
          <div className="product-info max-w-[420px] lg:sticky lg:top-24 self-start">
            <div className="info-header">
              <h1 className="text-2xl lg:text-3xl font-medium tracking-tight">{product.name}</h1>
              <p className="text-sm text-gray-400 uppercase tracking-widest mt-1 mb-1">
                SKU: {product.brand}
              </p>


              <div className="product-meta">
                <div className="rating">
                  <div className="stars">
                    {renderStars(calculateAverageRating())}
                  </div>
                  <span className="rating-count">
                    ({reviews.length} reviews)
                  </span>
                </div>


              </div>

              <div className="flex items-center gap-4 text-lg">
                <span className="text-xl font-semibold">
                  Rs. {product.price}
                </span>

                {product.originalPrice > product.price && (
                  <span className="line-through text-gray-400">
                    ₹{product.originalPrice}
                  </span>
                )}
              </div>

              <p className="tax-info">inclusive of all taxes</p>
            </div>

            {/* Size Selection */}
            <div className="size-section">
              <div className="size-header">
                <span className="size-label">Select Size</span>
                <span className="size-guide" onClick={() => navigate("/size-guide")}>Size Guide</span>
              </div>

              <div className="size-options">
                {product.sizes?.map((size) => (
                  <button
                    key={size}
                    className={`size-btn ${selectedSize === size ? 'active' : ''}`}
                    onClick={() => {
                      setSelectedSize(size);
                      setSizeError(false);
                    }}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>

            {/* Quantity */}
            <div className="quantity-section">
              <span className="quantity-label">Quantity</span>
              <div className="quantity-controls">
                <button
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  className="qty-btn"
                >
                  <FiMinus />
                </button>
                <span className="qty-value">{quantity}</span>
                <button
                  onClick={() => setQuantity(quantity + 1)}
                  className="qty-btn"
                >
                  <FiPlus />
                </button>
              </div>
            </div>

{sizeError && (
  <p className="text-red-500 text-xs mt-2">
    Please select a size before ordering
  </p>
)}
            <div className="mt-6 space-y-4">

              {/* Buttons */}
              <div className="flex flex-col gap-3">

                {/* Add to Cart */}
                {/* <button
      className={`w-full flex items-center justify-center gap-2 
      border border-black px-6 py-2 text-sm font-medium
      transition-all duration-200
      ${isAdded 
        ? "bg-black text-white" 
        : "bg-white text-black hover:bg-black hover:text-white"
      }`}
      onClick={handleCartButtonClick}
    >
      <FiShoppingBag />
      {isAdded ? "Go to Cart →" : "Add to Cart"}
    </button> */}


                {/* WhatsApp Order */}
                <button
                  className="w-full flex items-center justify-center gap-2 
      bg-black text-white px-6 py-2 text-sm font-medium
      hover:opacity-90 transition"
                  onClick={handleOrderClick}
                >
                  <FaWhatsapp className="text-green-500 text-lg" />
                  Order on WhatsApp
                </button>


                {/* Custom Order Banner */}
                <div className="flex items-start gap-3 p-3 border border-gray-200 rounded-lg bg-gray-50 text-sm">

                  <div className="text-lg">✨</div>

                  <div className="leading-tight">
                    <p className="font-medium text-black">
                      Looking for a personalised version of this piece?
                    </p>

                    <p className="text-gray-600 text-xs mt-1">
                      We accept custom orders in selected sizes and colours.
                    </p>

                    <button
                      onClick={handleCustomOrder}
                      className="text-black underline text-xs mt-1 hover:opacity-70"
                    >
                      Request Customisation →
                    </button>
                  </div>

                </div>



              </div>

              <ProductActionsExtra productName={product.name} />


              {/* Delivery Info */}
              <div className="mt-4 space-y-3 text-sm">

                {/* Free Delivery */}
                <div className="flex items-start gap-2">
                  <FiTruck className="text-black text-base" />
                  <div className="leading-tight">
                    <p className="font-medium text-black">Free Delivery</p>
                    {/* <p className="text-gray-500 text-xs">On orders above ₹999</p> */}
                  </div>
                </div>

                {/* COD */}
                <div className="flex items-center gap-2 text-sm">
                  <FaMoneyBillWave className="text-green-600 text-base" />

                  <span className="text-green-700 font-medium">
                    Cash on Delivery Available
                  </span>

                  <button
                    onClick={() => setShowCodTerms(true)}
                    className="text-gray-500 underline hover:text-gray-700 text-xs"
                  >
                    Terms
                  </button>
                </div>


                {showCodTerms && (
                  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4" onClick={() => setShowCodTerms(false)} >

                    <div className="bg-white rounded-lg p-6 max-w-sm w-full" onClick={(e) => e.stopPropagation()} >

                      <h3 className="text-lg font-semibold mb-3">
                        Cash on Delivery Terms
                      </h3>

                      <p className="text-sm text-gray-600 leading-relaxed mb-5">
                        To prevent fake orders, some Cash on Delivery orders require a
                        small booking amount of <span className="font-semibold">₹200</span>.
                        This amount will be deducted from the final order value at delivery.
                      </p>

                      {/* Buttons */}
                      <div className="flex flex-col gap-2">

                        <button
  // onClick={() => window.open("https://wa.me/918080595020?text=Hi%2C%20I%20want%20to%20pay%20₹200%20for%20my%20order")}
  className="w-full bg-green-600 text-white py-2 rounded-md text-sm hover:opacity-90 transition"
>
  Pay 200 to confirm via WhatsApp
</button>

                        {/* <button
                          onClick={() => setShowCodTerms(false)}
                          className="w-full border border-gray-300 py-2 rounded-md text-sm hover:bg-gray-50"
                        >
                          Maybe Later
                        </button> */}

                      </div>

                    </div>
                  </div>
                )}



              </div>

              {/* Share */}
              <ProductShare productName={product.name}
                productImage={product.images?.[0]} />
              {/* <div className="mt-3">
  <button className="flex items-center gap-1 text-sm text-black-500">
    Share
    <FiArrowUpRight className="text-sm" />
  </button>
</div> */}
            </div>


            {/* Product Details Accordion */}
            {/* Product Details Accordion */}
            <div className="product-accordion mt-10 md:mt-20 border-t border-gray-200 divide-y">

              {/* Description */}
              <div>
                <button
                  className="w-full flex items-center justify-between py-2 text-left text-gray-600 hover:text-black group"
                  onClick={() => toggleSection('description')}
                >
                  <span className="text-[14px] font-medium tracking-wide">
                    Description
                  </span>

                  <FiChevronDown
                    className={`transition-transform duration-300 ${openSections.description ? "rotate-180" : ""
                      }`}
                  />
                </button>

                <div
                  className={`grid transition-all duration-300 ease-in-out ${openSections.description
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                    }`}
                >
                  <div className="overflow-hidden pb-2 text-sm text-gray-600 leading-relaxed">
                    <p>{product.description}</p>
                  </div>
                </div>
              </div>


              {/* Product Details */}
              <div>
                <button
                  className="w-full flex items-center justify-between py-2 text-left text-gray-600 hover:text-black group"
                  onClick={() => toggleSection('details')}
                >
                  <span className="text-[14px] font-medium tracking-wide">
                    Product Details
                  </span>

                  <FiChevronDown
                    className={`transition-transform duration-300 ${openSections.details ? "rotate-180" : ""
                      }`}
                  />
                </button>

                <div
                  className={`grid transition-all duration-300 ease-in-out ${openSections.details
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                    }`}
                >
                  <div className="overflow-hidden pb-2 space-y-1 text-sm text-gray-600">

                    <div className="flex justify-between">
                      <span className="text-gray-500">Category</span>
                      <span>{product.category}</span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-gray-500">Sub Category</span>
                      <span>{product.subCategory}</span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-gray-500">Gender</span>
                      <span>{product.gender}</span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-gray-500">Color</span>
                      <span>{product.color?.join(', ')}</span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-gray-500">Material</span>
                      <span>Premium Quality</span>
                    </div>

                    {product.productDetails?.map((detail) => (
                      <div className="flex justify-between" key={detail.id}>
                        <span className="text-gray-500">{detail.name}</span>
                        <span>{detail.value}</span>
                      </div>
                    ))}

                  </div>
                </div>
              </div>


              {/* Care Instructions */}
              <div>
                <button
                  className="w-full flex items-center justify-between py-2 text-left text-gray-600 hover:text-black group"
                  onClick={() => toggleSection('care')}
                >
                  <span className="text-[14px] font-medium tracking-wide">
                    Care Instructions
                  </span>

                  <FiChevronDown
                    className={`transition-transform duration-300 ${openSections.care ? "rotate-180" : ""
                      }`}
                  />
                </button>

                <div
                  className={`grid transition-all duration-300 ease-in-out ${openSections.care
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                    }`}
                >
                  <div className="overflow-hidden pb-2 text-sm text-gray-600">
                    <ul className="list-disc pl-4 space-y-0.5">
                      <li>Gentle machine wash as per tag</li>
                      <li>Do not bleach</li>
                      <li>Dry inside out in shade</li>
                      <li>Warm iron if needed</li>
                      <li>Do not dry clean</li>
                    </ul>
                  </div>
                </div>
              </div>


              {/* About Brand */}
              <div>
                <button
                  className="w-full flex items-center justify-between py-2 text-left text-gray-600 hover:text-black group"
                  onClick={() => toggleSection('brand')}
                >
                  <span className="text-[14px] font-medium tracking-wide">
                    About The Brand
                  </span>

                  <FiChevronDown
                    className={`transition-transform duration-300 ${openSections.brand ? "rotate-180" : ""
                      }`}
                  />
                </button>

                <div
                  className={`grid transition-all duration-300 ease-in-out ${openSections.brand
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                    }`}
                >
                  <div className="overflow-hidden pb-2 text-sm text-gray-600 leading-relaxed">
                    <p>
                      {product.brand} is a premium contemporary fashion label focused on
                      modern silhouettes, quality fabrics, and timeless minimal design
                      crafted for everyday elegance.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>


        </div>

        {/* Ratings Summary */}
        <div className="flex flex-col md:flex-row gap-8 mb-12 items-start">

          {/* Left Rating */}
          <div className="flex flex-col items-start min-w-[120px]">

            <h3 className="text-sm font-semibold mb-2">
              Ratings
            </h3>

            <div className="flex items-center gap-2">

              <span className="text-3xl font-semibold">
                {calculateAverageRating()}
              </span>

              <span className="text-green-600 text-lg">
                ★
              </span>

            </div>

            <p className="text-xs text-gray-500 mt-1">
              {reviews.length} Verified Buyers
            </p>

          </div>

          {/* Rating Bars */}
          <div className="flex-1 w-full max-w-md">

            {[5, 4, 3, 2, 1].map((star) => {

              const count = reviews.filter(r => r.rating === star).length;

              const percentage = reviews.length
                ? (count / reviews.length) * 100
                : 0;

              return (
                <div key={star} className="flex items-center gap-2 mb-1">

                  <span className="text-xs w-6">
                    {star} ★
                  </span>

                  <div className="w-40 md:w-52 h-[3px] bg-gray-200 rounded-full overflow-hidden">
                    <div
                      className="h-[3px] bg-green-600 rounded-full"
                      style={{ width: `${percentage}%` }}
                    />
                  </div>

                  <span className="text-xs text-gray-500 w-6">
                    {count}
                  </span>

                </div>
              );

            })}

          </div>

        </div>


        {/* Reviews Section */}
        <div className="mt-20 border-t px-4 pt-16">
          <h2 className="text-2xl md:text-3xl font-semibold mb-10">
            Customer Reviews ({reviews.length})
          </h2>

          {reviewImages.length > 0 && (
            <div className="mb-14">



            </div>
          )}





          <button
            onClick={() => setShowReviewModal(true)}
            className="bg-black text-white px-6 py-2 rounded-lg hover:opacity-90 transition mb-10"
          >
            Write a Review
          </button>



          {/* Reviews List */}
          <div className="space-y-8">
            {reviews.length === 0 && (
              <p className="text-gray-500">
                No reviews yet. Be the first to review this product.
              </p>
            )}

            {reviews.map((review, index) => (
              <div
                key={index}
                className="border-b pb-8"
              >
                <div className="flex justify-between items-center mb-3">
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="bg-green-600 text-white text-xs px-1.5 py-0.5 rounded flex items-center gap-1">
                        {review.rating} ★
                      </span>
                      <span className="font-semibold">
                        {review.name}
                      </span>


                      <MdVerified className="text-green-600 text-sm" />

                      <span className="text-green-600 text-xs">
                        Verified
                      </span>

                    </div>
                    <p className="text-xs text-gray-500">
                      {new Date(review.createdAt || review.date)
                        .toLocaleDateString()}
                    </p>
                  </div>

                  {/* <div className="flex">
                    {renderStars(review.rating)}
                  </div> */}
                </div>

                <p className="text-gray-700 leading-relaxed mb-3">
                  {review.comment}
                </p>

                <div className="flex overflow-x-auto flex-shrink-0">
                  {review.images?.length > 0 && (
                    <div className="flex gap-2 mt-3 overflow-x-auto">
                      {review.images.map((img, i) => (
                        <img
                          key={i}
                          alt="productimg"
                          src={img}
                          onClick={() =>
                            setSelectedReview({
                              ...review,
                              startIndex: i
                            })
                          }
                          className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-md border border-gray-200 cursor-pointer hover:shadow-md hover:scale-105 transition flex-shrink-0"

                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>


          {/* Top Summary */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-14">

          </div>

        </div>



        {selectedReview && (
          <ReviewImageGallery
            images={selectedReview.images}
            startIndex={selectedReview.startIndex}
            onClose={() => setSelectedReview(null)}
          />
        )}

        {/* Related Products */}
{relatedProducts.length > 0 && (
  <div className="mt-10">
    
    <h2 className="text-lg md:text-xl font-semibold mb-6 text-gray-800">
      You May Also Like
    </h2>



    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
      
      {relatedProducts.map((product) => (

  
        
        <div
          key={product._id}
          onClick={() => navigate(`/product/${product._id}`)}
          className="cursor-pointer group relative"
        >
 

          {/* Image */}
          <div className="relative overflow-hidden bg-gray-100 aspect-[2/3]">

            <img
            //  src={product?.mainImage}
             src={product?.mainImage || "/placeholder.png"}
              alt={product?.name || "Product"} />
              className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
            

         

          </div>

          {/* Info */}
          <div className="mt-2 px-1">

            {/* Product Name (truncate) */}
            <h3 className="text-xs md:text-sm text-gray-800 truncate">
              {product.name}
            </h3>

            {/* Price */}
            <div className="flex items-center gap-2 mt-1">

              <span className="text-sm font-medium text-gray-900">
                ₹{product.price}
              </span>

              {product.originalPrice > product.price && (
                <span className="text-[11px] text-gray-400 line-through">
                  ₹{product.originalPrice}
                </span>
              )}
 {/* {savings > 0 && (
    <span className="ml-auto text-[10px] md:text-xs font-medium text-green-700 bg-green-50 border border-green-200 px-2 py-[2px] rounded-full">
      Save ₹{savings.toLocaleString()}
    </span>
  )} */}
            </div>

          </div>

        </div>
      ))}
    </div>

  </div>
)}
      </div>

      {showReviewModal && (
        <ReviewFormModal
          onClose={() => setShowReviewModal(false)}
          reviewForm={reviewForm}
          setReviewForm={setReviewForm}
          handleReviewSubmit={handleReviewSubmit}
          preview={preview}
          handleImageChange={handleImageChange}
        />
      )}
      {/* Toast Notification */}
      {showToast && (
        <div className={`toast-notification ${showToast.type}`}>
          {showToast.message}
        </div>
      )}



      <QuickOrderModal
        open={openOrderModal}
        onClose={() => setOpenOrderModal(false)}
        product={product}
        selectedSize={selectedSize}
        quantity={quantity}
      />



      {showImageModal && (
        <ImageLightbox
          images={allImages}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
          onClose={() => setShowImageModal(false)}
        />
      )}
    </div>
  );
};

export default ProductDetails;